(function($) {
    var Scripts = {
      init() {
        let self = this;
        this.bindEvents();
      },
  
      bindEvents() {
        var self = this;
        
        // hero vertical height
        $(document).ready(function() {
          self.swiperPrep();
          self.bindLocalAnchorScroll();
        });
      },

      bindLocalAnchorScroll() {
        $(document).off('click.dbackLocalAnchor', '.single-dback_event a[href^="#"]');
        $(document).on('click.dbackLocalAnchor', '.single-dback_event a[href^="#"]', function(e) {
          var href = $(this).attr('href');
          if (!href || href === '#' || href.length < 2) {
            return;
          }
          var $target = $(href);
          if (!$target.length) {
            return;
          }

          e.preventDefault();

          var headerOffset = $('.site-header').outerHeight() || 0;
          var targetTop = Math.max(0, $target.offset().top - headerOffset - 12);

          $('html, body').stop(true).animate({ scrollTop: targetTop }, 450);

          if (history && history.replaceState) {
            history.replaceState(null, '', href);
          } else {
            window.location.hash = href;
          }
        });
      },
  
  
      
      buildSwiper() {
        var $slides = $('.gallery-wrapper .slides');
        if (!$slides.length) {
          return false;
        }
        $slides.each(function () {
          var $el = $(this);
          if ($el.hasClass('slick-initialized')) {
            return;
          }
          $el.slick({
            infinite: true,
            autoplay: true,
            speed: 1000,
            fade: true,
            cssEase: 'ease-in-out',
            arrows: false,
            lazyLoad: 'ondemand',
            waitForAnimate: false,
          });
          $el.on('afterChange', function () {
            var newIdx = $el.slick('slickCurrentSlide');
            $('#slide_num').text(newIdx + 1);
          });
        });

        return true;
      },
  
      swiperClose() {
        $('.site-header.stuck.slideshowing').removeClass('slideshowing');
  
        let tlmodal2 = new TimelineLite();
        tlmodal2.to($('#project-slides-modal .modal-content'), 0.7, {
          opacity: 0,
          ease: Power1.easeInOut,
        })
        .to($('#project-slides-modal'), 0.5, {
          autoAlpha: 0,
          ease: Power1.easeInOut,
        }, "-=0.2");
      },
  
      swiperPrep() {
        let self = this;

        if (this._isMobile()) {
          return false;
        }
  
  
        if ($('.gallery-wrapper .slides').length) {
          this.buildSwiper();
  
          
  
          $(document).on('click', '.lightbox-link', function(e) {
            e.stopImmediatePropagation();
            e.preventDefault();
  
            let idx = $(e.target).attr('data-slideidx');
            $('.gallery-wrapper .slides').slick('slickGoTo', idx);
            $('#slide_num').text(idx);
            $('.site-header.stuck').addClass('slideshowing');
  
            let tlmodal = new TimelineLite();
            tlmodal.to($('#project-slides-modal'), 1, {
              autoAlpha: 1,
              ease: Power1.easeInOut,
            }, "+=0.1")
            .to($('#project-slides-modal .modal-content'), 0.6, {
              opacity: 1,
              ease: Power1.easeInOut,
            }, "-=0.2");
  
            // console.log('showing slide: ', $(".slides").slick('slickCurrentSlide'));
          });
  
          $(document).on('keydown', function(ev) {
            let keyCode = ev.keyCode;
            if (keyCode === 37) {// Left
              $('.gallery-wrapper .slides').slick('slickPrev');
            }
            if (keyCode === 39) { // Right
              $('.gallery-wrapper .slides').slick('slickNext');
            }
            if (keyCode === 27) {
              self.swiperClose(); // ESC
            }
          });
  
          $(document).off('click', '.gallery .swiper-button-next');
          $(document).on('click', '.gallery .swiper-button-next', function (e) {
            e.stopPropagation();
            e.preventDefault();
            $(this).closest('.swiper-container').find('.slides').first().slick('slickNext');
          });
  
          $(document).off('click', '.gallery .swiper-button-prev');
          $(document).on('click', '.gallery .swiper-button-prev', function (e) {
            e.stopPropagation();
            e.preventDefault();
            $(this).closest('.swiper-container').find('.slides').first().slick('slickPrev');
          });
  
          $(document).on('click', '.lb-close', function() {
            self.swiperClose();
          });
        }
  
        return true;
      },
  
  
      _isMobile() {
        let mobileBreakpoint = 768;
        let vpw = $(window).width();
        return (vpw < mobileBreakpoint);
      },
    };
  
    Scripts.init();
  })(jQuery);
  